// src/components/layout/Sidebar.jsx
// Rediseño Fase 3 — navegación lateral (sidebar). Se llevó aquí la navegación
// con permisos por rol y el badge + sockets de "Atención a Clientes" que antes
// vivían en el Topbar (lógica preservada 1:1). El Topbar quedó como barra
// superior delgada (búsqueda, break, campana, tema, perfil).
import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import ChatNavItem from './ChatNavItem';
import socket from '../../services/socket';
import { getUnreadCount } from '../../services/supportApi';
import {
    showNotification as showOsNotification,
    isTabHidden,
} from '../../services/notifications';

const Icon = ({ children, size = 18, stroke = 1.75 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth={stroke}
         strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        {children}
    </svg>
);
const I = {
    tickets: <Icon><path d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4z" /><path d="M13 5v14" strokeDasharray="2 3" /></Icon>,
    plus:    <Icon><path d="M12 5v14M5 12h14" /></Icon>,
    support: <Icon><path d="M3 12a9 9 0 0 1 18 0" /><path d="M21 16a2 2 0 0 1-2 2h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3zM3 16a2 2 0 0 0 2 2h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3z" /></Icon>,
    reports: <Icon><path d="M3 3v18h18" /><path d="M7 15l3-3 3 3 4-5" /></Icon>,
    auth:    <Icon><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="m9 12 2 2 4-4" /></Icon>,
    admin:   <Icon><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></Icon>,
    chev:    <Icon size={14}><path d="m9 18 6-6-6-6" /></Icon>,
    cog:     <Icon size={16}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></Icon>,
    hechos:  <Icon><path d="M12 3l7 3v6c0 4.2-2.9 7.9-7 9-4.1-1.1-7-4.8-7-9V6l7-3z" /><path d="M9.2 12l2 2 3.6-3.8" /></Icon>,
};

const SB_CSS = `
.sb-root {
    position: fixed; top: 0; left: 0; bottom: 0; z-index: 1045;
    width: 252px;
    display: flex; flex-direction: column;
    background: linear-gradient(180deg, var(--brand-900), var(--brand-800));
    color: #fff;
    box-shadow: 2px 0 18px rgba(8,29,73,.22);
    font-family: var(--font-sans);
    -webkit-font-smoothing: antialiased;
    transition: transform .22s cubic-bezier(.4,0,.2,1);
}
.sb-root * { box-sizing: border-box; }

.sb-brand {
    display: flex; align-items: center; gap: 10px;
    padding: 16px 18px; text-decoration: none; color: #fff;
    border-bottom: 1px solid rgba(255,255,255,.08);
}
.sb-brand img { height: 26px; width: auto; }
.sb-brand-name { font-weight: 700; letter-spacing: .01em; font-size: 15px; }

.sb-scroll { flex: 1; overflow-y: auto; padding: 12px 10px 16px; }
.sb-section-label {
    font-size: 10px; font-weight: 700; text-transform: uppercase;
    letter-spacing: .9px; color: rgba(255,255,255,.42);
    padding: 14px 12px 6px;
}

.sb-link {
    display: flex; align-items: center; gap: 11px;
    width: 100%;
    color: rgba(255,255,255,.78);
    background: transparent; border: none; text-decoration: none;
    padding: 9px 12px; border-radius: 10px;
    font-size: 14px; font-weight: 500; font-family: inherit;
    cursor: pointer; position: relative; text-align: left;
    transition: background .14s, color .14s;
    margin-bottom: 2px;
}
.sb-link:hover { background: rgba(255,255,255,.09); color: #fff; }
.sb-link.active { background: rgba(255,255,255,.14); color: #fff; font-weight: 600; }
.sb-link.active::before {
    content: ''; position: absolute; left: 0; top: 8px; bottom: 8px;
    width: 3px; border-radius: 3px; background: var(--accent-amber, #f5c542);
}
.sb-link .sb-label { flex: 1; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sb-link .sb-chev { opacity: .6; transition: transform .15s; }
.sb-link.open .sb-chev { transform: rotate(90deg); }

.sb-badge {
    display: inline-flex; align-items: center; justify-content: center;
    min-width: 20px; height: 20px; padding: 0 6px;
    border-radius: 999px; background: #dc2626; color: #fff;
    font-size: 11px; font-weight: 700; line-height: 1;
    box-shadow: 0 0 0 2px rgba(220,38,38,.25);
    animation: sb-pulse 1.6s ease-in-out infinite;
}
@keyframes sb-pulse {
    0%,100% { box-shadow: 0 0 0 2px rgba(220,38,38,.25); }
    50%     { box-shadow: 0 0 0 5px rgba(220,38,38,.08); }
}

/* Subgrupo (acordeón) */
.sb-sub { margin: 0 0 4px; padding-left: 8px; overflow: hidden; }
.sb-sub-head {
    font-size: 10px; font-weight: 700; text-transform: uppercase;
    letter-spacing: .7px; color: rgba(255,255,255,.4);
    padding: 8px 12px 3px;
}
.sb-sublink {
    display: block; color: rgba(255,255,255,.72);
    text-decoration: none; padding: 7px 12px; border-radius: 8px;
    font-size: 13px; font-weight: 500; transition: background .14s, color .14s;
}
.sb-sublink:hover { background: rgba(255,255,255,.08); color: #fff; }
.sb-sublink.active { background: rgba(255,255,255,.13); color: #fff; font-weight: 600; }

/* Layout shell: empuja el contenido a la derecha en desktop */
.app-content { margin-left: 252px; min-height: 100vh; transition: margin-left .22s cubic-bezier(.4,0,.2,1); }

/* Backdrop móvil */
.sb-backdrop { display: none; }

/* Escritorio: ocultar el sidebar (toggle persistido) y expandir el contenido */
@media (min-width: 993px) {
    .sb-root.collapsed { transform: translateX(-100%); }
    .app-content.sb-collapsed { margin-left: 0; }
}

@media (max-width: 992px) {
    .sb-root { transform: translateX(-100%); }
    .sb-root.open { transform: translateX(0); }
    .app-content, .app-content.sb-collapsed { margin-left: 0; }
    .sb-backdrop.show {
        display: block; position: fixed; inset: 0; z-index: 1044;
        background: rgba(8,16,32,.5); backdrop-filter: blur(1px);
    }
}
`;

export default function Sidebar({ open = false, collapsed = false, onClose }) {
    const { user } = useContext(AuthContext);
    const location = useLocation();
    const [reportsOpen, setReportsOpen] = useState(false);
    const [adminOpen, setAdminOpen] = useState(false);

    // Cerrar el sidebar móvil al navegar
    useEffect(() => {
        if (onClose) onClose();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const isAdmin   = user?.role === 'admin';
    const isLeader  = user?.role === 'leader';
    const isAgent   = user?.role === 'agent';
    const canAuth   = !!user?.canAuthorize;
    const isStaffLeader = isAdmin || isLeader;
    const canHandleSupport = isAdmin || ((isLeader || isAgent) && !!user?.canHandleSupport);

    const showAgents       = isStaffLeader;
    const showUsers        = isAdmin;
    const showDepartments  = isStaffLeader || (isAgent && canAuth);
    const showCanned       = isAdmin || isAgent || isLeader;
    const showSla          = isStaffLeader || (isAgent && (user?.isLeader || canAuth));
    const showUnitPolicies = isAdmin;
    const showMigration    = isAdmin;
    const showInvitations  = isStaffLeader;
    const showHolidays     = isAdmin;
    const showBusinessHours = isAdmin;
    const showGuards       = isStaffLeader || isAgent;
    const showChatPolicies = isStaffLeader;

    const hasAdminMenu =
        showAgents || showUsers || showDepartments || showCanned ||
        showSla || showUnitPolicies || showMigration || showInvitations ||
        showHolidays || showBusinessHours || showChatPolicies || showGuards;

    const isActive = (path, exact = false) =>
        exact ? location.pathname === path
              : location.pathname === path || location.pathname.startsWith(path + '/');

    const reportsPaths = ['/leader-reports', '/csat-feedback', '/production-reports'];
    const reportsActive = reportsPaths.some(p => isActive(p));
    const adminPaths = [
        '/agents', '/usuarios', '/departments', '/canned', '/sla', '/business-hours', '/guardias',
        '/unit-policies', '/chat-policies', '/support-routing', '/support-knowledge',
        '/support-faqs', '/support-sla', '/support-reports', '/holidays',
        '/invitations', '/migration', '/admin-health', '/revalidacion/admin',
    ];
    const adminActive = adminPaths.some(p => isActive(p));

    // Auto-expandir el grupo activo
    useEffect(() => { if (reportsActive) setReportsOpen(true); }, [reportsActive]);
    useEffect(() => { if (adminActive) setAdminOpen(true); }, [adminActive]);

    // ── Badge de Atención a Clientes (contador + sockets), movido del Topbar ──
    const [supportUnread, setSupportUnread] = useState(0);

    const playPing = () => {
        try {
            const AC = window.AudioContext || window.webkitAudioContext;
            if (!AC) return;
            const ctx = new AC();
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.type = 'sine';
            osc.frequency.setValueAtTime(880, ctx.currentTime);
            gain.gain.setValueAtTime(0.001, ctx.currentTime);
            gain.gain.exponentialRampToValueAtTime(0.18, ctx.currentTime + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.18);
            osc.connect(gain).connect(ctx.destination);
            osc.start(); osc.stop(ctx.currentTime + 0.2);
        } catch { /* noop */ }
    };

    useEffect(() => {
        if (!canHandleSupport) { setSupportUnread(0); return; }
        getUnreadCount().then(r => setSupportUnread(r?.count || 0)).catch(() => {});
    }, [canHandleSupport, location.pathname]);

    useEffect(() => {
        if (!canHandleSupport) return undefined;
        const focusInbox = () => {
            try { window.focus(); } catch {}
            if (location.pathname !== '/support') window.location.href = '/support';
        };
        const onMessage = ({ message, conversationId }) => {
            if (message?.from !== 'client') return;
            if (location.pathname === '/support' || location.pathname.startsWith('/support/')) return;
            setSupportUnread(c => c + 1);
            playPing();
            if (isTabHidden()) {
                showOsNotification({
                    title: 'Nuevo mensaje — Atención a Clientes',
                    body:  (message.text || '').slice(0, 140) || '(adjunto)',
                    tag:   `support-msg-${conversationId}`,
                    onClick: focusInbox,
                });
            }
        };
        const onConvUpdated = (patch) => {
            if (patch?.status === 'closed') {
                getUnreadCount().then(r => setSupportUnread(r?.count || 0)).catch(() => {});
                return;
            }
            if (patch?.status === 'escalated' && isTabHidden()) {
                showOsNotification({
                    title: '⚠ Conversación escalada a humano',
                    body:  'Una conversación necesita atención. Click para abrir el inbox.',
                    tag:   `support-escalated-${patch._id}`,
                    requireInteraction: true,
                    onClick: focusInbox,
                });
            }
        };
        const onCreated = (conv) => {
            if (location.pathname === '/support' || location.pathname.startsWith('/support/')) return;
            setSupportUnread(c => c + 1);
            playPing();
            if (isTabHidden()) {
                showOsNotification({
                    title: 'Nueva conversación — Atención a Clientes',
                    body:  `${conv.snapshot?.name || conv.client?.name || 'Cliente'} (${conv.snapshot?.marca || conv.client?.marca || ''})`,
                    tag:   `support-conv-${conv._id}`,
                    onClick: focusInbox,
                });
            }
        };
        const onReconnect = () => {
            getUnreadCount().then(r => setSupportUnread(r?.count || 0)).catch(() => {});
        };
        socket.on('supportMessage',     onMessage);
        socket.on('supportConvUpdated', onConvUpdated);
        socket.on('supportConvCreated', onCreated);
        socket.on('connect',            onReconnect);
        return () => {
            socket.off('supportMessage',     onMessage);
            socket.off('supportConvUpdated', onConvUpdated);
            socket.off('supportConvCreated', onCreated);
            socket.off('connect',            onReconnect);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canHandleSupport, location.pathname]);

    return (
        <>
            <style>{SB_CSS}</style>
            <aside className={`sb-root${open ? ' open' : ''}${collapsed ? ' collapsed' : ''}`}>
                <Link to="/dashboard" className="sb-brand">
                    <img src="/caprepa.svg" alt="Caprepa"
                         onError={({ currentTarget }) => { currentTarget.style.display = 'none'; }} />
                    <span className="sb-brand-name">Caprepa Desk</span>
                </Link>

                <nav className="sb-scroll">
                    <Link to="/tickets"
                          className={`sb-link${isActive('/tickets', false) && !isActive('/tickets/new', true) ? ' active' : ''}`}>
                        {I.tickets}<span className="sb-label">Tickets</span>
                    </Link>
                    <Link to="/tickets/new"
                          className={`sb-link${isActive('/tickets/new', true) ? ' active' : ''}`}>
                        {I.plus}<span className="sb-label">Nuevo ticket</span>
                    </Link>

                    {(isAdmin || isLeader || isAgent) && <ChatNavItem />}

                    {canHandleSupport && (
                        <Link to="/support" className={`sb-link${isActive('/support', true) ? ' active' : ''}`}>
                            {I.support}<span className="sb-label">Atención Clientes</span>
                            {supportUnread > 0 && (
                                <span className="sb-badge" aria-label={`${supportUnread} mensajes nuevos`}>
                                    {supportUnread > 99 ? '99+' : supportUnread}
                                </span>
                            )}
                        </Link>
                    )}

                    {/* Hechos Operativos — módulo aislado del resto del ecosistema.
                        La visibilidad la decide el servidor en /auth/me, porque la
                        elegibilidad sale del puesto del intranet contra el catálogo
                        de la política, no de un flag local. */}
                    {user?.incidents?.hasAccess && (
                        <Link to="/hechos" className={`sb-link${isActive('/hechos', true) ? ' active' : ''}`}>
                            {I.hechos}<span className="sb-label">Hechos Operativos</span>
                        </Link>
                    )}
                    {user?.incidents?.hasAccess && isAdmin && (
                        <Link to="/hechos/admin" className={`sb-link${isActive('/hechos/admin') ? ' active' : ''}`} style={{ paddingLeft: 34 }}>
                            {I.cog}<span className="sb-label">Configurar HO</span>
                        </Link>
                    )}

                    {/* Directorio de correos — acceso por lista blanca (canMailDirectory).
                        Resuelto por el servidor en /auth/me; el permiso real se
                        revalida en cada request de /api/mail-directory. */}
                    {user?.mailDirectory?.hasAccess && (
                        <Link to="/directorio-correos" className={`sb-link${isActive('/directorio-correos') ? ' active' : ''}`}>
                            {I.mail || I.hechos}<span className="sb-label">Directorio de correos</span>
                        </Link>
                    )}

                    {(user?.role === 'authorizer' || isAdmin || isLeader || (isAgent && canAuth)) && (
                        <Link to="/authorizations" className={`sb-link${isActive('/authorizations') ? ' active' : ''}`}>
                            {I.auth}<span className="sb-label">Autorizaciones</span>
                        </Link>
                    )}

                    {/* Reportes */}
                    {isStaffLeader ? (
                        <>
                            <button type="button"
                                className={`sb-link${reportsActive ? ' active' : ''}${reportsOpen ? ' open' : ''}`}
                                onClick={() => setReportsOpen(v => !v)} aria-expanded={reportsOpen}>
                                {I.reports}<span className="sb-label">Reportes</span>
                                <span className="sb-chev">{I.chev}</span>
                            </button>
                            {reportsOpen && (
                                <div className="sb-sub">
                                    <Link to="/leader-reports" className={`sb-sublink${isActive('/leader-reports') ? ' active' : ''}`}>Tickets</Link>
                                    <Link to="/csat-feedback" className={`sb-sublink${isActive('/csat-feedback') ? ' active' : ''}`}>CSAT</Link>
                                    <Link to="/production-reports" className={`sb-sublink${isActive('/production-reports') ? ' active' : ''}`}>Producción</Link>
                                </div>
                            )}
                        </>
                    ) : isAgent && (
                        <Link to="/csat-feedback" className={`sb-link${isActive('/csat-feedback') ? ' active' : ''}`}>
                            {I.reports}<span className="sb-label">CSAT</span>
                        </Link>
                    )}

                    {/* Administración */}
                    {hasAdminMenu && (
                        <>
                            <button type="button"
                                className={`sb-link${adminActive ? ' active' : ''}${adminOpen ? ' open' : ''}`}
                                onClick={() => setAdminOpen(v => !v)} aria-expanded={adminOpen}>
                                {I.admin}<span className="sb-label">Administración</span>
                                <span className="sb-chev">{I.chev}</span>
                            </button>
                            {adminOpen && (
                                <div className="sb-sub">
                                    <p className="sb-sub-head">Gente</p>
                                    {showAgents      && <Link to="/agents" className={`sb-sublink${isActive('/agents') ? ' active' : ''}`}>Agentes</Link>}
                                    {showUsers       && <Link to="/usuarios" className={`sb-sublink${isActive('/usuarios') ? ' active' : ''}`}>Usuarios</Link>}
                                    {showInvitations && <Link to="/invitations" className={`sb-sublink${isActive('/invitations') ? ' active' : ''}`}>Invitaciones</Link>}

                                    <p className="sb-sub-head">Organización</p>
                                    {showDepartments   && <Link to="/departments" className={`sb-sublink${isActive('/departments') ? ' active' : ''}`}>Departamentos</Link>}
                                    {showBusinessHours && <Link to="/business-hours" className={`sb-sublink${isActive('/business-hours') ? ' active' : ''}`}>Horario laboral</Link>}
                                    {showGuards        && <Link to="/guardias" className={`sb-sublink${isActive('/guardias') ? ' active' : ''}`}>Guardias de sábado</Link>}
                                    {showHolidays      && <Link to="/holidays" className={`sb-sublink${isActive('/holidays') ? ' active' : ''}`}>Feriados</Link>}
                                    {showUnitPolicies  && <Link to="/unit-policies" className={`sb-sublink${isActive('/unit-policies') ? ' active' : ''}`}>Políticas Unidades</Link>}
                                    {isAdmin           && <Link to="/revalidacion/admin" className={`sb-sublink${isActive('/revalidacion/admin') ? ' active' : ''}`}>Revalidación Vale Amigo</Link>}

                                    <p className="sb-sub-head">Tickets</p>
                                    {showCanned && <Link to="/canned" className={`sb-sublink${isActive('/canned') ? ' active' : ''}`}>Respuestas rápidas</Link>}
                                    {showSla    && <Link to="/sla" className={`sb-sublink${isActive('/sla') ? ' active' : ''}`}>SLA</Link>}

                                    {canHandleSupport && (
                                        <>
                                            <p className="sb-sub-head">Atención a clientes</p>
                                            <Link to="/support-routing" className={`sb-sublink${isActive('/support-routing') ? ' active' : ''}`}>Ruteo</Link>
                                            <Link to="/support-knowledge" className={`sb-sublink${isActive('/support-knowledge') ? ' active' : ''}`}>Conocimiento del bot</Link>
                                            <Link to="/support-faqs" className={`sb-sublink${isActive('/support-faqs') ? ' active' : ''}`}>FAQs del bot</Link>
                                            <Link to="/support-sla" className={`sb-sublink${isActive('/support-sla') ? ' active' : ''}`}>SLA</Link>
                                            <Link to="/support-reports" className={`sb-sublink${isActive('/support-reports') ? ' active' : ''}`}>Reportes</Link>
                                        </>
                                    )}

                                    {(showChatPolicies || showMigration || isAdmin) && (
                                        <>
                                            <p className="sb-sub-head">Otros</p>
                                            {showChatPolicies && <Link to="/chat-policies" className={`sb-sublink${isActive('/chat-policies') ? ' active' : ''}`}>Permisos de chat</Link>}
                                            {showMigration    && <Link to="/migration" className={`sb-sublink${isActive('/migration') ? ' active' : ''}`}>Migración</Link>}
                                            {isAdmin          && <Link to="/admin-health" className={`sb-sublink${isActive('/admin-health') ? ' active' : ''}`}>Salud del sistema</Link>}
                                        </>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </nav>
            </aside>
            <div className={`sb-backdrop${open ? ' show' : ''}`} onClick={onClose} />
        </>
    );
}
